import OlMap from 'ol/Map'
import MultiPolygon from 'ol/geom/MultiPolygon'
import { BackendProject, Project } from '../types/project'
import { Permissions, UserSettings } from '.'

// Updates the current project with the provided data (much like React's setState)
// export const PROJECT_SET = 'project_set'
// Updates the current properties with the provided properties (much like React's setState)
export const PROJECT_PROPERTIES_SET = 'project_property_set'
// Resets state with data fetch by apiClient.getProject
export const PROJECT_RESET = 'project_reset'

export const SET_ZONAL_STATISTICS = 'set_zonal_statistics'

// Initialize a new tool
export const TOOL_REGISTER = 'tool_register'
// Set a tool active/inactive
export const TOOL_SET_ACTIVE = 'tool_set_active'
// Enable a tool
export const TOOL_ENABLE = 'tool_enable'
// Make it impossible to activate a tool
export const TOOL_DISABLE = 'tool_disable'

// Initializes (and overwrites the current) permissions in the store
export const PERMISSIONS_SET = 'permissions_set'

// Initializes (and overwrites the current) map in the store
export const MAP_SET = 'map_set'

// Sets the geometry of the boundaries (updates are, crop polygon, etc.)
// export const BOUNDARIES_SET = 'boundaries_set'

// Set current user (after sign in, for example)
export const USER_SET = 'user_set'

// The projects' annotations where updated; "hasAnnotations" tells
// if the project has annotations after the last update
export const ANNOTATIONS_UPDATED = 'annotations_updated'

export const USER_SETTINGS_UPDATED = 'user_settings_updated'

export const SET_ORTHO_SOURCE = 'set_ortho_source'

export interface Tool {
  id: string
  active?: boolean
  disabled?: boolean
}

export interface BaseAction {
  type: string
}

interface ProjectSetAction extends BaseAction {
  type: 'project_set'
  project: Partial<Project>
  immediate: boolean
}

interface ProjectResetAction extends BaseAction {
  type: 'project_reset'
  // eslint-disable-next-line camelcase
  project: BackendProject
  skipSave?: boolean
}

interface ProjectPropertiesSetAction extends BaseAction {
  type: 'project_property_set'
  properties: Record<string, unknown>
}

interface ZonalStatisticsSetAction extends BaseAction {
  type: 'set_zonal_statistics'
  zonalStatistics: string
}

interface ToolRegisterAction extends BaseAction {
  type: 'tool_register'
  tool: Tool
}

interface ToolSetActiveAction extends BaseAction {
  type: 'tool_set_active'
  tool: Tool
}

interface ToolEnableAction extends BaseAction {
  type: 'tool_enable'
  tool: Tool
}

interface ToolDisableAction extends BaseAction {
  type: 'tool_disable'
  tool: Tool
}

interface PermissionSetAction extends BaseAction {
  type: 'permissions_set'
  permissions: Record<string, boolean>
}

interface MapSetAction extends BaseAction {
  type: 'map_set'
  map: OlMap
}

interface BoundariesSetAction extends BaseAction {
  type: 'boundaries_set'
  geometry: MultiPolygon
}

interface UserSetAction extends BaseAction {
  type: 'user_set'
  user: { id: number; permissions: Permissions }
}

interface AnnotationsUpdatedAction extends BaseAction {
  type: 'annotations_updated'
  hasAnnotations: boolean
}

interface UserSettingsUpdated extends BaseAction {
  type: 'user_settings_updated'
  userSettings: UserSettings
}

export type StoreAction =
  | ProjectSetAction
  | ProjectResetAction
  | ProjectPropertiesSetAction
  | ZonalStatisticsSetAction
  | ToolRegisterAction
  | ToolSetActiveAction
  | ToolEnableAction
  | ToolDisableAction
  | PermissionSetAction
  | MapSetAction
  | BoundariesSetAction
  | UserSetAction
  | AnnotationsUpdatedAction
  | UserSettingsUpdated
